import * as canvasActions from '../canvas/actions';
import * as mainActions from '../main/actions';
import * as mainSelectors from '../main/selectors';
import * as sidebarActions from '../sidebar/actions';

const canvasMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const state = getState();
    const elementDragFlag = mainSelectors.getElementDragFlag(state);

    // note that elementDragFlag only used for desktop studio
    if (elementDragFlag) {
      if (
        action.type === sidebarActions.CHANGE_SIDEBAR_TABKEY ||
        action.type === canvasActions.canvasActionType.UNSELECT_ALL_IMAGE ||
        action.type === canvasActions.canvasActionType.UNSELECT_ALL_TEXT
      ) {
        // not switch to WhatsNext if dragging element on canvas and release mouse button outside canvas
        // note: clear the flag after the final action(UNSELECT_ALL_TEXT) in step2.onClick is dispatched
        if (action.type === canvasActions.canvasActionType.UNSELECT_ALL_TEXT)
          dispatch(mainActions.setElementDragFlag(false));
        return null;
      } else {
        return next(action);
      }
    } else {
      return next(action);
    }
  };
export default canvasMiddleware;
